// extracted by mini-css-extract-plugin
export default {"mCard":"XB-z","image":"YB-z","imageNoBackground":"ZB-z","imageHasCategory":"_B-z","fullWidth":"aC-z"};